import * as React from 'react';
import { useRef, useEffect } from 'react';
import clsx from 'clsx';

type ChatContainerProps = {
  children: React.ReactNode;
  className?: string;
};

export function ChatContainer({ children, className }: ChatContainerProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  });

  return (
    <div
      ref={containerRef}
      className={clsx('d-flex overflow-auto', className)}
      role="log"
      style={{ minHeight: 0 }}>
      <div className="d-flex w-100 flex-column">
        {children}
        <div
          ref={bottomRef}
          style={{ height: '1px', width: '100%', flexShrink: 0 }}
        />
      </div>
    </div>
  );
}
